import { GithubTokenMessageListenerService } from './github-token-message-listener.service';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class GithubToolsTokenRequestListener extends GithubTokenMessageListenerService {
  domain = 'github.tools.sap';
}
